import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const menuLinks = [
    { to: '/hakkimizda', label: 'Hakkımızda' },
    { to: '/hizmetler', label: 'Hizmetler' },
    { to: '/referanslar', label: 'Referanslar' },
    { to: '/hizmetal', label: 'Hizmet Al' },
    { to: '/kuryeol', label: 'Kurye Ol' },
  ];

  const legalLinks = [
    { to: '/kullanim-kosullari', label: 'Kullanım Koşulları' },
    { to: '/sartlar-ve-kosullar', label: 'Şartlar ve Koşullar' },
    { to: '/gizlilik-politikasi', label: 'Gizlilik Politikası' },
    { to: '/cerez-politikasi', label: 'Çerez Politikası' },
    { to: '/kisisel-verilerinizin-korunmasi', label: 'KVKK' },
  ];

  const socialLinks = [
    {
      href: 'https://www.facebook.com/motopack.com.tr',
      label: 'Facebook',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      )
    },
    {
      href: 'https://www.instagram.com/motopack_tr/',
      label: 'Instagram',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
        </svg>
      )
    },
    {
      href: 'https://motopack.com.tr/',
      label: 'LinkedIn',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      )
    },
  ];

  return (
    <footer style={{
      background: '#0f172a',
      color: '#94a3b8',
      padding: '2rem 0 0 0',
    }}>
      <div style={{
        maxWidth: 1280,
        margin: '0 auto',
        padding: '0 1.5rem',
      }}>
        {/* Main Footer Content */}
        <div
          className="footer-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1.5fr 1fr 1.5fr 1.2fr',
            gap: '2rem',
            paddingBottom: '1.5rem',
          }}
        >
          {/* Brand Column */}
          <div>
            <Link
              to="/"
              onClick={scrollToTop}
              style={{
                display: 'inline-block',
                marginBottom: '0.75rem',
              }}
            >
              <img
                src="/Logo footer.png"
                alt="Motopack Logo"
                style={{
                  maxWidth: 100,
                  height: 'auto',
                  display: 'block',
                }}
              />
            </Link>
            <p style={{
              fontSize: '0.8125rem',
              color: '#64748b',
              marginBottom: '1rem',
              lineHeight: 1.4,
            }}>
              Hızlı teslimat hizmetleri
            </p>
            {/* Social Links */}
            <div style={{
              display: 'flex',
              gap: '0.375rem',
            }}>
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  aria-label={link.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#1e293b',
                    borderRadius: 6,
                    color: '#64748b',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#334155';
                    e.currentTarget.style.color = '#3b82f6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#1e293b';
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Menu Column */}
          <div>
            <h4 style={{
              fontSize: '0.875rem',
              fontWeight: 600,
              color: '#f1f5f9',
              marginBottom: '0.75rem',
              textTransform: 'uppercase',
            }}>
              MENU
            </h4>
            <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
            }}>
              {menuLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={scrollToTop}
                  style={{
                    color: '#94a3b8',
                    textDecoration: 'none',
                    fontSize: '0.8125rem',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#94a3b8'}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Legal Column */}
          <div>
            <h4 style={{
              fontSize: '0.875rem',
              fontWeight: 600,
              color: '#f1f5f9',
              marginBottom: '0.75rem',
              textTransform: 'uppercase',
            }}>
              Yasal
            </h4>
            <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
            }}>
              {legalLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={scrollToTop}
                  style={{
                    color: '#94a3b8',
                    textDecoration: 'none',
                    fontSize: '0.8125rem',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#94a3b8'}
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Column */}
          <div>
            <h4 style={{
              fontSize: '0.875rem',
              fontWeight: 600,
              color: '#f1f5f9',
              marginBottom: '0.75rem',
              textTransform: 'uppercase',
            }}>
              İletişim
            </h4>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
            }}>
              <a
                href="mailto:info@motopack.com.tr"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                }}
              >
                info@motopack.com.tr
              </a>
              <a
                href="tel:+908505325989"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontSize: '0.8125rem',
                  fontWeight: 500,
                }}
              >
                0850 532 59 89
              </a>
              <address style={{
                fontStyle: 'normal',
                color: '#64748b',
                fontSize: '0.75rem',
                lineHeight: 1.5,
              }}>
                Güzeloluk mah. 1830 sk.<br />
                No:202/B Florya S.<br />
                Muratpaşa / Antalya
              </address>
            </div>
          </div>
        </div>

        {/* Copyright Bar */}
        <div style={{
          borderTop: '1px solid #1e293b',
          padding: '1rem 0',
          textAlign: 'center',
        }}>
          <span style={{
            fontSize: '0.75rem',
            color: '#64748b',
          }}>
            Copyright © 2020-2025 Motopack Lojistik ve Teknoloji A.Ş. Tüm hakları saklıdır.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;